import * as Actions from '../../actions';

const initialState = { data: null };

const viewWashFacilitiesReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_WASH_FACILITY_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default viewWashFacilitiesReducer;
